import type { IconSvgObject } from './types';

const ArrangeByNumbersNineOneIcon: IconSvgObject = [
  ["path", { d: "M6.99991 21.0002V14L5.49991 15M6.99991 21.0002L5.49991 21M6.99991 21.0002L8.49991 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99991 6.5V3H4.99991V6.5H8.99991ZM8.99991 6.5V10H4.99991", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.4999 4V19.1964M13.9999 17.5L16.4999 20L18.9999 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrangeByNumbersNineOneIcon;
